declare const zxcvbn: any;
declare const localization: Localization;

export default class PasswordControl {
    private readonly passwordInputsContainer: JQuery;
    private passwordStrength = 0;
    private readonly minPasswordStrength = 1;
    private readonly passwordInput: JQuery;
    private readonly showPasswordBtn: JQuery;
    private readonly zxcvbn: any;

    constructor(passwordInputsContainer, zxcvbnInstance: any = null) {
        this.passwordInputsContainer = passwordInputsContainer;
        this.passwordInput = this.passwordInputsContainer.find(".password");
        this.showPasswordBtn = this.passwordInputsContainer.find(".btn-show-password");
        this.zxcvbn = zxcvbnInstance != null ? zxcvbnInstance : zxcvbn;
    }

    public init(): void {
        this.createPasswordStrengthEstimator();
        this.initShowPassword();
    }

    private createPasswordStrengthEstimator(): void {
        const passwordStrengthEstimatorContainer = this.passwordInputsContainer.find(".password-strength-container");
        const passwordStrengthEstimator = passwordStrengthEstimatorContainer.find(".password-strength-estimator");
        const zxcvbnMaxPasswordScore = 4;
        const passwordStrengthMsgContainer = this.passwordInputsContainer.find("#password-strength-msg");

        this.passwordInput.on("input", (event) => {
            const password = jq(event.target).val() as string;
            const passwordRulesDefined = this.passwordInput.parents("form").data("validator") !== undefined;
            const passwordRegExp = passwordRulesDefined ? new RegExp(this.passwordInput.rules().regex) : new RegExp(".*");
            // remove classes with password strength
            passwordStrengthEstimator.removeClass(`${PasswordStrengthClasses["0"]} ${PasswordStrengthClasses["1"]}
                     ${PasswordStrengthClasses["2"]} ${PasswordStrengthClasses["3"]}`);
            if (!(passwordRegExp.test(password))) {
                passwordStrengthMsgContainer.empty();
            } else {
                const passwordTestResult = this.zxcvbn(password);
                this.passwordStrength = passwordTestResult.score as number;
                passwordStrengthEstimator.addClass(PasswordStrengthClasses[this.passwordStrength - 1]);

                if (this.passwordStrength <= this.minPasswordStrength) {
                    localization.translateAsync("weak-pswd", "UserPasswordViewModel")
                        .then((weakPasswordTranslation) => {
                            passwordStrengthMsgContainer.html(weakPasswordTranslation.result.value);
                        });
                } else {
                    localization.translateAsync("strong-pswd", "UserPasswordViewModel")
                        .then((strongPasswordTranslation) => {
                            passwordStrengthMsgContainer.html(strongPasswordTranslation.result.value);
                        });
                }
            }
        });
    }

    private initShowPassword(): void {
        this.showPasswordBtn.on("mousedown touchstart", () => {
            this.passwordInput.attr("type", "text");
        });

        this.showPasswordBtn.on("mouseup touchend mouseleave", () => {
            this.passwordInput.attr("type", "password");
        });
    }
}

enum PasswordStrengthClasses {
    weak,
    medium,
    good,
    strong,
}
